import { ValueOf } from '@/types/util';

export const walletUserStatus = {
  AVAILABLE: '有効',
  STOP: '利用停止',
  WITHDRAWAL: '退会',
} as const;

export type WalletUserStatusKey = keyof typeof walletUserStatus;
export type WalletUserStatusValue = ValueOf<typeof walletUserStatus>;

export const WalletUserStatusKeys = Object.keys(walletUserStatus) as WalletUserStatusKey[];

/** v-select用items */
export const WalletUserStatusItems = WalletUserStatusKeys
  .map((key) => ({
    title: walletUserStatus[key],
    value: key,
  }));
